import {GraphQLClient} from 'graphql-request';
import {
  _IsLink,
  _ToTitleCase,
  FILE_API,
  GRAPH_API,
  ANALYTICS_API,
  IlogisticsTypeId,
  EApplicationStateType,
  EInputOrderPaymentType,
} from 'constants/index';
import {
  lshGETAUTH,
  lshREMOVEAUTH,
  lshSAVEAUTH,
} from 'services/LocalStorageService';
import NavigationService from 'services/NavigationService';
import {reduxClearAll, reduxSetUser} from 'appredux/actions';
import SocketService from 'services/SocketService';

export {
  _IsLink,
  _ToTitleCase,
  FILE_API,
  GRAPH_API,
  ANALYTICS_API,
  IlogisticsTypeId,
  EApplicationStateType,
  EInputOrderPaymentType,
  lshGETAUTH,
  lshREMOVEAUTH,
  lshSAVEAUTH,
  NavigationService,
  reduxClearAll,
  reduxSetUser,
  SocketService,
};

export const graphqlRequestHandler = (
  name: any,
  query: any,
  variables: any,
  headers = {},
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const client = new GraphQLClient(GRAPH_API, {
      headers: {
        ...headers,
        platform: 'WEB_SUPPLIER',
        requestSourceUserType: 'supplier',
      },
    });
    client
      .request(query, variables)
      .then((data: any) => {
        resolve(name ? data[name] : data);
      })
      .catch((error: any) => {
        let shouldReject = true;
        if (error.response) {
          error.response.errors.forEach((item: any) => {
            const tokenErrorMessages = ['not authenticate'];
            if (tokenErrorMessages.includes(item.message.toLocaleLowerCase())) {
              shouldReject = true;
              lshREMOVEAUTH();
              reduxClearAll();
              NavigationService.navigate('/token-expired');
            }
          });
        }
        if (shouldReject) {
          reject(
            error.response
              ? error.response.errors
                ? error.response.errors.map((i: any) => i.message)
                : error.response
              : error,
          );
        }
      });
  });
};
